import HelperMixin from '../../Shared/HelperMixin.vue';
import PaginationHelper from '../../Shared/PaginationHelper.vue';

const ST = { PendingReceipt: 3 };

export default {
    name: 'DirectDispatchReceive',
    mixins: [HelperMixin],
    components: { PaginationHelper },

    async created() {
        await this.CheckLoginStatus();
        if (!this.loginDetails || !this.canVerifyReceiptsUi()) {
            this.logout();
            return;
        }
        await this.loadStockings();
        this.GetInfo();
    },

    computed: {
        totalPages() {
            return Math.ceil(this.pages / this.pageSize);
        },
        branchStockings() {
            const bid = this.loginDetails && this.loginDetails.branchesId;
            if (bid == null || bid === '') return [];
            return (this.allStockings || []).filter((s) => {
                if (s.branchesId !== bid) return false;
                const k = s.stockingKind;
                if (k === 4) return false;
                return true;
            });
        },
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 15,
            pages: 0,
            Info: [],
            allStockings: [],
            receiveDialog: false,
            receiveRow: null,
            receiveLines: [],
            submitting: false,
        };
    },

    methods: {
        async loadStockings() {
            try {
                const r = await this.$http.GetAllStocking();
                this.allStockings = r.data.info || [];
            } catch {
                this.allStockings = [];
            }
        },

        GetInfo(pageNo) {
            this.pageNo = pageNo || 1;
            this.$blockUI.Start();
            this.$http.GetDirectDispatch(this.pageNo, this.pageSize, null, ST.PendingReceipt)
                .then((res) => {
                    this.$blockUI.Stop();
                    this.Info = res.data.info || [];
                    this.pages = res.data.count || 0;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.Info = [];
                    this.pages = 0;
                });
        },

        openReceive(row) {
            this.$blockUI.Start();
            this.$http.GetDirectDispatchOne(row.id)
                .then((r) => {
                    this.$blockUI.Stop();
                    const d = r.data;
                    if (!d.canReceive) {
                        this.$helper.ShowMessage('info', 'تنبيه', 'هذا السند ليس بانتظار الاستلام.');
                        return;
                    }
                    this.receiveRow = d;
                    const defaultSid = this.branchStockings.length === 1 ? this.branchStockings[0].id : null;
                    this.receiveLines = (d.lines || []).map((ln) => ({
                        lineId: ln.id,
                        productName: ln.productName,
                        quantity: ln.quantity,
                        targetStockingId: defaultSid,
                        quantityGood: ln.quantity,
                        quantityDamaged: 0,
                    }));
                    this.receiveDialog = true;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },

        submitReceive() {
            if (!this.receiveRow) return;
            for (let i = 0; i < this.receiveLines.length; i++) {
                const L = this.receiveLines[i];
                if (!L.targetStockingId) {
                    this.$helper.ShowMessage('warning', 'تنبيه', `اختر مخزن الاستلام للسطر: ${L.productName}`);
                    return;
                }
                const g = parseInt(L.quantityGood, 10) || 0;
                const d = parseInt(L.quantityDamaged, 10) || 0;
                if (g + d !== L.quantity) {
                    this.$helper.ShowMessage('warning', 'تنبيه', `الكميات للصنف ${L.productName} يجب أن يكون مجموعها ${L.quantity}`);
                    return;
                }
            }
            const body = {
                lines: this.receiveLines.map((L) => ({
                    lineId: L.lineId,
                    targetStockingId: L.targetStockingId,
                    quantityGood: parseInt(L.quantityGood, 10) || 0,
                    quantityDamaged: parseInt(L.quantityDamaged, 10) || 0,
                })),
            };
            this.submitting = true;
            this.$http.DirectDispatchReceive(this.receiveRow.id, body)
                .then(() => {
                    this.submitting = false;
                    this.receiveDialog = false;
                    this.$helper.ShowMessage('success', 'تم', 'تم تسجيل الاستلام.');
                    this.GetInfo(this.pageNo);
                })
                .catch((err) => {
                    this.submitting = false;
                    this.$helper.ShowMessage('error', 'خطأ', err.response && err.response.data ? err.response.data : '');
                });
        },
    },
};
